



import Footer from "../footer";
import HeaderNav from "../headerNav";
import DataReviews from "../utils";
import Location from "../location";
import ButtonCta from "../buttonCta";
import "./index.scss";
import Imagens from "./fotos";
import BannerImage from '../slowImages';



const Home = () => {
  const bannerImages = Imagens.map((img) => (
    <BannerImage key={img.id} foto={img.foto} titulo={img.titulo}/>
  ));

  return (
    <>
      <section>
        <HeaderNav />
      </section>

      <main className="container-main">
        <ul>{bannerImages}</ul>
      </main>

      <section className="container-data-reviews">
        <DataReviews />
      </section>

      <section className="button-cta">
        <ButtonCta text="Quero me Inscrever" to="register"/>
      </section>

      <section> 
        <Location />
      </section>

      <section>
        <Footer />
      </section>
    </>
  );
};

export default Home;
